import { responsiveClassNames, responsivePropDependency, responsiveVariables, } from "../../../utilities/props.js";
import s from "./border.module.css";
import "./borderWidth.css";
const border = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderTop = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w-top", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderBottom = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w-bottom", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderStart = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w-start", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderEnd = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w-end", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderBlock = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w-block", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderInline = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-border-w-inline", responsivePropDependency(value, (value) => {
            return value ? "1px" : "0px";
        })),
    };
};
export const borderColor = (value) => {
    if (!value)
        return {};
    return {
        classNames: responsiveClassNames(s, "--border", value),
    };
};
export default border;
